// Drag-and-drop identifiers shared across the React Grid Layout DnD system.
//
// The dnd-kit payload carries a `header` (see src/lib/Draggable.tsx) which is read
// back in handleDragStart/handleDragEnd as `activeId.headerDragging`. These constants
// keep the magic strings in one place instead of being scattered through the infra.

export const DRAG_HEADER = {
  // A trade ESID dragged out of the Trade Blotter (Action Summary) ESID cell.
  ESID: "ESID",
  // A block dragged out of the Trade Creation grid's Security cell.
  BLOCK: "Block",
} as const;

// RGL widgets are identified by their layout key `i`, formatted as
// `${displayName}-${uuid}` (see updateWorkspaceTabActionAdd). We therefore match on the
// displayName fragment — note the SPACE in "Swap Curve" (the displayName), NOT "SwapCurve"
// (the component key).

// Widgets that accept a dropped trade ESID from the blotter.
export const widgetAcceptsESIDDrop = (widgetI: string): boolean =>
  widgetI.includes("Tile") || widgetI.includes("Swap Curve");

// Widgets that accept a dropped Creation block (dragged from the Security cell).
export const widgetAcceptsBlockDrop = (widgetI: string): boolean =>
  widgetI.includes("Swap Curve");
